import { ISectionTime } from '../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
export class CheckTimeWithInstructorUtility {
  private ONLINE: number = 8;
  areTimesNotSpecified(sectionTimes: ISectionTime[]): boolean {
    return this.isAnyTimeMissing(sectionTimes);
  }
  private isAnyDayNotSure(sectionTimes: ISectionTime[]): boolean {
    return _4.some(sectionTimes, (sectionTime) => sectionTime.day_of_week === this.ONLINE);
  }

  private isAnyTimeMissing(sectionTimes: ISectionTime[]): boolean {
    return _4.some(sectionTimes, (sectionTime) => _4.isEmpty(sectionTime.from_tm) || _4.isEmpty(sectionTime.to_tm));
  }
}

angular.module('capability-ng-scheduler').service('isCheckTimeWithInstructor', CheckTimeWithInstructorUtility);
angular.module('capability-ng-scheduler').service('ngCheckTimeWithInstructorUtility', CheckTimeWithInstructorUtility);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/utilities/is_check_time_with_instructor_fn.ts